import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import Button from '@Components/Buttons/Button'
import { PermissionActions } from '@App/enum/permission-actions'
import { UserInfo } from '@Entities/user/user'
import { MyUserGroup } from '@Scenes/RightsholderScene/RightsholderMaintenanceUserPermissionsProfile'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import MyUserGroupsMapped from '@Scenes/RightsholderScene/RightsholderMaintenanceUserPermissionsProfile/AssignedPermissionGroups/MyUserGroupsMapped'
import UsersForUserTable from '@Scenes/RightsholderScene/RightsholderMaintenanceUserPermissionsProfile/AssignedPermissionGroups/UsersForUserTable'

interface AssignedPermissionGroupsProps {
    editIsDisabled: boolean
    setEditIsDisabled: (editIsDisabled: boolean) => void
    onCancelEdit: (user: UserInfo) => void
    onOpenConfirmPopup: (newActionType: PermissionActions) => void
    myUserGroups: MyUserGroup[]
    editActionsGroups: MyUserGroup[]
    rightsholderUser: UserInfo
    setMyUserGroups: (userGroups: MyUserGroup[]) => void
    setEditActionsGroups: (editActionGroups: MyUserGroup[]) => void
}

const AssignedPermissionGroups = (props: AssignedPermissionGroupsProps) => {
    const { userStore } = useContext<RootStore>(StoresContext)
    const {
        editIsDisabled,
        setEditIsDisabled,
        onCancelEdit,
        onOpenConfirmPopup,
        myUserGroups,
        editActionsGroups,
        rightsholderUser,
        setMyUserGroups,
        setEditActionsGroups,
    } = props

    const isSubmitDisabled = () => !editActionsGroups.length || myUserGroups.filter((item) => item.checked).length === 0
    const isSelf = userStore.userInfo.exposedId === rightsholderUser.exposedId

    return (
        <div className="permissions-wrapper">
            <div className="permissions-block">
                <p className="title small bold">Assigned Permissions Group</p>
                <div className="buttons-block">
                    {editIsDisabled ? (
                        <Button
                            mainColor
                            type="primary"
                            {...(isSelf ? { disabled: true, title: 'You cannot update your own permissions' } : {})}
                            onClick={() => setEditIsDisabled(false)}
                        >
                            Edit
                        </Button>
                    ) : (
                        <>
                            <Button mainColor type="secondary" onClick={() => onCancelEdit(rightsholderUser)}>
                                Cancel
                            </Button>
                            <Button
                                mainColor
                                type="primary"
                                onClick={() => onOpenConfirmPopup(PermissionActions.changePermissions)}
                                disabled={isSubmitDisabled() || userStore.isInternal}
                            >
                                Save
                            </Button>
                        </>
                    )}
                </div>
                <MyUserGroupsMapped
                    myUserGroups={myUserGroups}
                    rightsholderUser={rightsholderUser}
                    setMyUserGroups={setMyUserGroups}
                    editIsDisabled={editIsDisabled}
                    setEditActionsGroups={setEditActionsGroups}
                />
            </div>
            <div className="people-block">
                <p className="title small bold">Others with similar permissions</p>
                <UsersForUserTable />
            </div>
        </div>
    )
}

export default observer(AssignedPermissionGroups)
